export default {};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/i18n/en.ts